module.exports = __webpack_public_path__ + "static/coca-cola-logo-6b6185992b9aa8ea5a442b3287eaf645.png";